import {RemotePostSurgeryConfirm} from 'data/usecases/private/booking-flow/surgery/remote-post-surgery-confirm';
import {PostSurgeryConfirm} from 'domain/usecases/private/booking-flow/surgery/post-surgery-confirm';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostSurgeryConfirm = (): PostSurgeryConfirm =>
	new RemotePostSurgeryConfirm(
		makeBFFApiUrl(BookingFlowEndPoints.surgeryConfirm),
		makeAuthorizeHttpClientDecorator(),
	);
